const store = {
    namespaced: true,
    state: {},
    getters: {
        getSubscriptionFeatures: (state) => state,
    },
    mutations: {},
    actions: {},
};

const factory = (subscriptionFeatures = {}) => {
    return {
        ...store,
        state: {
            ...store.state,
            ...subscriptionFeatures,
        },
    };
};

export { store as default, factory };
